import React from 'react';
/**
 * `PageInfoProduct` renders sidebar content for product selection pages.
 *
 * It can show a "Reasons to protect" titled list and an optional
 * "Just so you know" section sourced from CMS product page content.
 */
import List from '../common/List';
import { useTranslation } from 'react-i18next';
import { CommonValidation } from '../common/CommonValidation/commonValidation';
import { useAppSelector } from '../../app-state/Hooks';

type PageInfoProductProps = {
  showReasonsToProtect: boolean;
};

const PageInfoProduct = ({
  showReasonsToProtect
}: PageInfoProductProps): JSX.Element => {
  const reasonsToProtect = useAppSelector((s) => s.content.reasonsToProtect);
  const justSoYouKnow = useAppSelector(
    (s) => s.content.productPage.justSoYouKnow
  );

  const { t } = useTranslation();

  const showJustSoYouKnow = CommonValidation.isNotEmpty(justSoYouKnow);

  return (
    <div className='info'>
      {showReasonsToProtect && (
        <div className='m05-bottom'>
          <List id='reasons-to-protect' list={reasonsToProtect} />
        </div>
      )}

      {showJustSoYouKnow && (
        <div>
          {showReasonsToProtect && <hr />}

          <div className='m05-bottom'>
            <p className='p1-bold m05-bottom'>
              {t('page-info.just-so-you-know')}
            </p>
            <p className='p3 m05-bottom cms'>{justSoYouKnow}</p>
          </div>
        </div>
      )}
    </div>
  );
};
export default PageInfoProduct;
